/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import { IHerbalOrderInfographicViewProps } from './herbal-order-infographic';

export default (props: IHerbalOrderInfographicViewProps) => {
    const { config, moduleProps, containerProps, contentContainerProps, rowProps, steps } = props;

    const containerStyles: React.CSSProperties = {
        backgroundColor: config.backgroundColor || '#E3DFD6',
        color: 'white'
    };

    return (
        <Module {...moduleProps}>
            <Node {...containerProps} style={containerStyles}>
                <Node {...contentContainerProps}>
                    <Node {...rowProps} style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div className='col-md-4'>{steps.step1}</div>
                        <div className='col-md-4'>{steps.step2}</div>
                        <div className='col-md-4'>{steps.step3}</div>
                    </Node>
                </Node>
            </Node>
        </Module>
    );
};
